import type { InjectionKey } from 'vue'
import type { InvestmentProject } from '@/server/api/buyer-front/types'

export const investmentProjectKey = Symbol('InvestmentProject') as InjectionKey<InvestmentProject>
